(() => {
  const page = document.querySelector('[data-quote-page]');
  if (!page) return;
  const summary = page.querySelector('[data-quote-page-summary]');
  const total = page.querySelector('[data-quote-page-total]');
  const setText = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const start = async () => {
    await customElements.whenDefined('quote-drawer');
    const drawer = document.querySelector('quote-drawer');
    const api = await drawer.ready();
    const updatePrices = (row) => {
      if (!row.quoteProduct) return;
      const input = row.querySelector('.raq_qty');
      const variant = row.quoteProduct.variants.find((v) => String(v.id) === input.dataset.vid);
      if (!variant) return;
      const item = api.get_added_item_list().find((i) => String(i.variant_id) === input.dataset.vid);
      const extra = Number(item?.total_extra_price || 0) * 100 * Number(api.get_current_currency_rate?.() || 1);
      const quantity = Math.max(1, Number(input.value) || 1);
      const signature = [quantity, variant.price, variant.compare_at_price, extra].join(':');
      if (row.dataset.priceSignature === signature) return;
      row.dataset.priceSignature = signature;
      for (const [selector, multiplier] of [['.quote-page__unit', 1], ['.quote-page__line-total', quantity]]) {
        const target = row.querySelector(selector);
        target.replaceChildren(node('span', 'price__current', drawer.money((variant.price + extra) * multiplier, false)));
        if (variant.compare_at_price > variant.price) target.append(node('s', 'price__was', drawer.money((variant.compare_at_price + extra) * multiplier, false)));
      }
    };
    const enhance = () => {
      const inputs = page.querySelectorAll('.raq_qty');
      summary.hidden = !inputs.length;
      page.querySelector('.cart').classList.toggle('quote-page__empty', !inputs.length);
      setText(total, page.querySelector('.raq_item_total_con')?.textContent.trim() || '');
      const nativeButton = page.querySelector('#sc-shopify-load-submit-popup');
      nativeButton?.closest('.row')?.classList.add('quote-page__original-button');
      inputs.forEach((input) => {
        const row = input.closest('.ql_quantity_container')?.parentElement?.parentElement;
        if (!row) return;
        if (!row.dataset.quoteEnhanced) {
          row.dataset.quoteEnhanced = 'true';
          row.classList.add('quote-page__row');
          const [image, details, quantity] = [...row.children];
          image.classList.add('quote-page__image');
          details.classList.add('quote-page__details');
          quantity.classList.add('quote-page__quantity');
          const title = details.querySelector('a[href*="/products/"]');
          title?.removeAttribute('target');
          const imageLink = image.querySelector('a');
          if (title && imageLink) { imageLink.href = title.href; imageLink.removeAttribute('target'); }
          input.setAttribute('aria-label', drawer.dataset.quantity + ': ' + (title?.textContent.trim() || ''));
          input.step = '1';
          input.inputMode = 'numeric';
          const controls = node('div', 'quote-drawer__quantity');
          const minus = node('button', '', '−');
          const plus = node('button', '', '+');
          [minus, plus].forEach((button) => button.type = 'button');
          minus.setAttribute('aria-label', drawer.dataset.decrease);
          plus.setAttribute('aria-label', drawer.dataset.increase);
          input.before(controls);
          controls.append(minus, input, plus);
          [minus, plus].forEach((button, index) => button.addEventListener('click', () => {
            input.value = String(Math.max(1, Number(input.value) + (index ? 1 : -1)));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }));
          const remove = quantity.querySelector('.raq-item-remove');
          remove.replaceChildren(drawer.querySelector('[data-quote-trash]').content.cloneNode(true));
          remove.classList.add('cart-item__remove');
          remove.setAttribute('aria-label', drawer.dataset.remove + ': ' + (title?.textContent.trim() || ''));
          details.append(node('div', 'quote-page__unit', details.querySelector('.row_unitprice')?.textContent.replace(/^[^:]+:\s*/, '').trim()));
          row.append(node('div', 'quote-page__line-total', details.querySelector('.row_unittotal span')?.textContent.trim()));
          const handle = title ? new URL(title.href).pathname.split('/products/')[1]?.split('/')[0] : null;
          if (handle) drawer.nativeProduct(decodeURIComponent(handle)).then((product) => {
            if (!product) return;
            row.quoteProduct = product;
            drawer.addVendor(details, product);
            updatePrices(row);
          });
        }
        row.querySelector('.quote-drawer__quantity button').disabled = Number(input.value) <= 1;
        updatePrices(row);
      });
      if (!inputs.length) {
        const empty = page.querySelector('#no_item');
        if (empty && !empty.querySelector('a') && getComputedStyle(empty).display !== 'none') {
          empty.append(page.querySelector('[data-quote-page-empty]').content.cloneNode(true));
        }
      }
    };
    page.addEventListener('change', (event) => {
      const input = event.target.closest('.raq_qty');
      if (!input) return;
      const items = api.get_added_item_list();
      const quantity = Number(input.value);
      if (!Number.isSafeInteger(quantity) || quantity < 1) {
        input.value = String(items.find((item) => String(item.variant_id) === input.dataset.vid)?.qty || 1);
      }
      api.set_added_item_list(items.map((item) => String(item.variant_id) === input.dataset.vid ? { ...item, qty: Number(input.value) } : item));
      drawer.syncApp();
      enhance();
    }, true);
    document.addEventListener('quote:drawer-closed', () => {
      const inputs = [...page.querySelectorAll('.raq_qty')];
      const items = api.get_added_item_list();
      if (inputs.length !== items.length || inputs.some((input) => !items.some((item) => String(item.variant_id) === input.dataset.vid))) {
        location.reload();
        return;
      }
      inputs.forEach((input) => {
        const item = items.find((entry) => String(entry.variant_id) === input.dataset.vid);
        if (Number(input.value) !== Number(item.qty)) {
          input.value = String(item.qty);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    const observer = new MutationObserver(enhance);
    observer.observe(page.querySelector('.page__content'), { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
    enhance();
  };
  start().catch(() => {});
})();
